// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/.pnpm/css-loader@6.8.1_webpack@5.89.0/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ul {
  list-style: none;
}`, "",{"version":3,"sources":["webpack://./src/app/templates/template-top5/template-top5.component.scss","webpack://./../../../=%3E%20finsuro/finsuro.mail/frontend/src/app/templates/template-top5/template-top5.component.scss"],"names":[],"mappings":"AAAA;EACI,gBAAA;ACCJ","sourcesContent":["ul {\n    list-style: none;\n}","ul {\n  list-style: none;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
